import React from 'react'

export const Second = () => {
    return (
        <>
            <span className={ `_title _medium _center _opaque` } >Replay</span>
            <span className={ `_title _medium _center` } >28 Nov – 13 Dic</span>
        </>
    )
}